<div class="content-bar">
  <div class="displayFlex">
    <div class="displayFlex contentTitle">
      <p class="textAlert bold">Alertas nuevas</p>
      <p class="textAlert">VS</p>
      <p class="textAlert bold">Alertas cerradas</p>
    </div>
    <button
      (click)="selected = 'Diario'; getDay()"
      [ngClass]="{ selectedClass: selected == 'Diario' }"
      mat-stroked-button
    >
      Diario
    </button>
    <button
      (click)="selected = 'Semanal'; getWeek()"
      [ngClass]="{ selectedClass: selected == 'Semanal' }"
      mat-stroked-button
      class="margin-side"
    >
      Semanal
    </button>
    <button
      (click)="selected = 'Mensual'; getYear()"
      [ngClass]="{ selectedClass: selected == 'Mensual' }"
      mat-stroked-button
    >
      Mensual
    </button>
  </div>

  <div>
    <div class="divChart" #contentLine id="contentLine">
      <canvas id="bar" #bar height="300"></canvas>
    </div>
  </div>
</div>
